import { CallbackProperty, Cartesian3 } from "cesium";
import { convertCartesian3ToSerializableCartographic } from "../utils/convert-cartesian3-to-serializable-cartographic";
import { EditPoint } from "./edit-point";
import { PointProps } from "./point-edit-options";
import { SerializableCartographic } from "./serializable-cartographic";

export interface CesiumPointWithProps {
    position: Cartesian3;
    pointProps: PointProps;
}

export interface CartographicEditPointParentEntity {
    getId(): string;
    isStaticEntity: boolean;
}

export class CartographicEditPoint extends EditPoint {
    private cartographic: SerializableCartographic;
    private isCartographicValid = true;

    constructor(
        private readonly entity: CartographicEditPointParentEntity,
        position: Cartesian3,
        pointProps?: PointProps,
        isVirtualPoint?: boolean
    ) {
        super(entity.getId(), position.clone(), pointProps, isVirtualPoint);

        this.cartographic = convertCartesian3ToSerializableCartographic(position);
    }

    public setPosition(position: Cartesian3) {
        super.setPosition(position);

        this.isCartographicValid = false;
    }

    public getCartographic() {
        if (!this.isCartographicValid) {
            this.cartographic = convertCartesian3ToSerializableCartographic(this.getPosition() as Cartesian3);
            this.isCartographicValid = true;
        }

        return this.cartographic;
    }

    public getPositionCallbackProperty() {
        return new CallbackProperty(this.getPosition.bind(this), this.entity.isStaticEntity);
    }
}
